(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[12076,54223],{

/***/ 15805:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony import */ var _swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(26042);
/* harmony import */ var _swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(69396);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var prop_types__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(45697);
/* harmony import */ var prop_types__WEBPACK_IMPORTED_MODULE_9___default = /*#__PURE__*/__webpack_require__.n(prop_types__WEBPACK_IMPORTED_MODULE_9__);
/* harmony import */ var classnames__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(94184);
/* harmony import */ var classnames__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(classnames__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var next_dynamic__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(5152);
/* harmony import */ var next_dynamic__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(next_dynamic__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var utils_constants__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(96076);
/* harmony import */ var UI_components_Typography__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(59654);
/* harmony import */ var UI_components_Typography_utils_useTypography__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(18422);
/* harmony import */ var _styles_module_scss__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(89494);
/* harmony import */ var _styles_module_scss__WEBPACK_IMPORTED_MODULE_3___default = /*#__PURE__*/__webpack_require__.n(_styles_module_scss__WEBPACK_IMPORTED_MODULE_3__);










var Animated = next_dynamic__WEBPACK_IMPORTED_MODULE_2___default()(function() {
    return __webpack_require__.e(/* import() */ 61971).then(__webpack_require__.bind(__webpack_require__, 61971));
}, {
    loadableGenerated: {
        webpack: function() {
            return [
                /*require.resolve*/(61971)
            ];
        }
    }
});
var SectionTitle = function(param) {
    var type = param.type, titleStyle = param.titleStyle, title = param.title, titleVariant = param.titleVariant, secondTitle = param.secondTitle, secondTitleVariant = param.secondTitleVariant, subtitle = param.subtitle, secondSubtitle = param.secondSubtitle, description = param.description, secondDescription = param.secondDescription, className = param.className, children = param.children;
    var titleSegments = title === null || title === void 0 ? void 0 : title.split("||");
    var descriptionParagraphs = description === null || description === void 0 ? void 0 : description.split("||");
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
        className: classnames__WEBPACK_IMPORTED_MODULE_1___default()((_styles_module_scss__WEBPACK_IMPORTED_MODULE_3___default().sectionTitleContainer), (_styles_module_scss__WEBPACK_IMPORTED_MODULE_3___default())[type], className, titleStyle),
        children: [
            title && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(Animated, (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z)({}, utils_constants__WEBPACK_IMPORTED_MODULE_6__/* .REVEAL_ANIMATION_PROPS */ .kt), {
                transitionDelay: 50,
                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(UI_components_Typography__WEBPACK_IMPORTED_MODULE_7__["default"], {
                    "data-title": true,
                    isBold: true,
                    size: UI_components_Typography_utils_useTypography__WEBPACK_IMPORTED_MODULE_8__/* .TYPOGRAPHY_SIZE.headline38 */ .y3.headline38,
                    mobileSize: UI_components_Typography_utils_useTypography__WEBPACK_IMPORTED_MODULE_8__/* .TYPOGRAPHY_SIZE.headline24 */ .y3.headline24,
                    variant: titleVariant,
                    className: (_styles_module_scss__WEBPACK_IMPORTED_MODULE_3___default().title),
                    children: titleSegments.length === 1 ? title : titleSegments.map(function(segment) {
                        return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(UI_components_Typography__WEBPACK_IMPORTED_MODULE_7__["default"], {
                            "data-title": true,
                            isBold: true,
                            size: UI_components_Typography_utils_useTypography__WEBPACK_IMPORTED_MODULE_8__/* .TYPOGRAPHY_SIZE.headline38 */ .y3.headline38,
                            mobileSize: UI_components_Typography_utils_useTypography__WEBPACK_IMPORTED_MODULE_8__/* .TYPOGRAPHY_SIZE.headline24 */ .y3.headline24,
                            variant: "span",
                            className: (_styles_module_scss__WEBPACK_IMPORTED_MODULE_3___default().title),
                            children: segment
                        });
                    })
                })
            })),
            subtitle && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(Animated, (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z)({}, utils_constants__WEBPACK_IMPORTED_MODULE_6__/* .REVEAL_ANIMATION_PROPS */ .kt), {
                transitionDelay: 100,
                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(UI_components_Typography__WEBPACK_IMPORTED_MODULE_7__["default"], {
                    "data-subtitle": true,
                    size: UI_components_Typography_utils_useTypography__WEBPACK_IMPORTED_MODULE_8__/* .TYPOGRAPHY_SIZE.paragrapgh16 */ .y3.paragrapgh16,
                    className: (_styles_module_scss__WEBPACK_IMPORTED_MODULE_3___default().subtitle),
                    children: subtitle
                })
            })),
            descriptionParagraphs && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(Animated, (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z)({}, utils_constants__WEBPACK_IMPORTED_MODULE_6__/* .REVEAL_ANIMATION_PROPS */ .kt), {
                transitionDelay: 100,
                children: descriptionParagraphs === null || descriptionParagraphs === void 0 ? void 0 : descriptionParagraphs.map(function(text, index) {
                    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(UI_components_Typography__WEBPACK_IMPORTED_MODULE_7__["default"], {
                        "data-description": true,
                        size: UI_components_Typography_utils_useTypography__WEBPACK_IMPORTED_MODULE_8__/* .TYPOGRAPHY_SIZE.paragrapgh16 */ .y3.paragrapgh16,
                        className: (_styles_module_scss__WEBPACK_IMPORTED_MODULE_3___default().description),
                        children: text
                    }, "paragraph/".concat(index));
                })
            })),
            secondTitle && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(Animated, (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z)({}, utils_constants__WEBPACK_IMPORTED_MODULE_6__/* .REVEAL_ANIMATION_PROPS */ .kt), {
                transitionDelay: 150,
                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(UI_components_Typography__WEBPACK_IMPORTED_MODULE_7__["default"], {
                    isBold: true,
                    "data-second-title": true,
                    size: UI_components_Typography_utils_useTypography__WEBPACK_IMPORTED_MODULE_8__/* .TYPOGRAPHY_SIZE.headline24 */ .y3.headline24,
                    variant: secondTitleVariant,
                    className: (_styles_module_scss__WEBPACK_IMPORTED_MODULE_3___default().title),
                    children: secondTitle
                })
            })),
            secondSubtitle && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(Animated, (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z)({}, utils_constants__WEBPACK_IMPORTED_MODULE_6__/* .REVEAL_ANIMATION_PROPS */ .kt), {
                transitionDelay: 200,
                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(UI_components_Typography__WEBPACK_IMPORTED_MODULE_7__["default"], {
                    "data-second-subtitle": true,
                    className: (_styles_module_scss__WEBPACK_IMPORTED_MODULE_3___default().subtitle),
                    children: secondSubtitle
                })
            })),
            secondDescription && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(Animated, (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z)({}, utils_constants__WEBPACK_IMPORTED_MODULE_6__/* .REVEAL_ANIMATION_PROPS */ .kt), {
                transitionDelay: 200,
                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(UI_components_Typography__WEBPACK_IMPORTED_MODULE_7__["default"], {
                    "data-second-description": true,
                    className: (_styles_module_scss__WEBPACK_IMPORTED_MODULE_3___default().description),
                    children: secondDescription
                })
            })),
            children
        ]
    });
};
SectionTitle.defaultProps = {
    type: "default",
    titleStyle: "",
    subtitle: "",
    description: null,
    className: null,
    title: null,
    secondTitle: "",
    secondSubtitle: "",
    secondDescription: "",
    titleVariant: "h2",
    secondTitleVariant: "h3"
};
SectionTitle.propTypes = {
    type: (prop_types__WEBPACK_IMPORTED_MODULE_9___default().string),
    titleStyle: (prop_types__WEBPACK_IMPORTED_MODULE_9___default().string),
    title: (prop_types__WEBPACK_IMPORTED_MODULE_9___default().string),
    secondTitle: (prop_types__WEBPACK_IMPORTED_MODULE_9___default().string),
    subtitle: (prop_types__WEBPACK_IMPORTED_MODULE_9___default().string),
    secondSubtitle: (prop_types__WEBPACK_IMPORTED_MODULE_9___default().string),
    description: (prop_types__WEBPACK_IMPORTED_MODULE_9___default().string),
    secondDescription: (prop_types__WEBPACK_IMPORTED_MODULE_9___default().string),
    className: (prop_types__WEBPACK_IMPORTED_MODULE_9___default().string),
    titleVariant: (prop_types__WEBPACK_IMPORTED_MODULE_9___default().string),
    secondTitleVariant: (prop_types__WEBPACK_IMPORTED_MODULE_9___default().string)
};
/* harmony default export */ __webpack_exports__["default"] = (SectionTitle);


/***/ }),

/***/ 59654:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony import */ var _swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(26042);
/* harmony import */ var _swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(69396);
/* harmony import */ var _swc_helpers_src_object_without_properties_mjs__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(99534);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var prop_types__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(45697);
/* harmony import */ var prop_types__WEBPACK_IMPORTED_MODULE_5___default = /*#__PURE__*/__webpack_require__.n(prop_types__WEBPACK_IMPORTED_MODULE_5__);
/* harmony import */ var _utils_useTypography__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(18422);






var Typography = function(props) {
    var _ref = (0,_utils_useTypography__WEBPACK_IMPORTED_MODULE_1__/* .useTypography */ .tj)(props), Tag = _ref.Tag, classes = _ref.classes, children = _ref.children, onClick = _ref.onClick, tabIndex = _ref.tabIndex, role = _ref.role, rest = (0,_swc_helpers_src_object_without_properties_mjs__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)(_ref, [
        "Tag",
        "classes",
        "children",
        "onClick",
        "tabIndex",
        "role"
    ]);
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(Tag, (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)({
        className: classes,
        onClick: onClick,
        tabIndex: tabIndex,
        role: role
    }, rest), {
        children: children
    }));
};
Typography.defaultProps = {
    variant: _utils_useTypography__WEBPACK_IMPORTED_MODULE_1__/* .TYPOGRAPHY_TAGS.p */ .w1.p,
    size: _utils_useTypography__WEBPACK_IMPORTED_MODULE_1__/* .TYPOGRAPHY_SIZE.paragrapgh16 */ .y3.paragrapgh16
};
Typography.propTypes = {
    children: (prop_types__WEBPACK_IMPORTED_MODULE_5___default().node.isRequired),
    isBold: (prop_types__WEBPACK_IMPORTED_MODULE_5___default().bool),
    variant: (prop_types__WEBPACK_IMPORTED_MODULE_5___default().string),
    className: (prop_types__WEBPACK_IMPORTED_MODULE_5___default().string),
    size: prop_types__WEBPACK_IMPORTED_MODULE_5___default().oneOf(Object.values(_utils_useTypography__WEBPACK_IMPORTED_MODULE_1__/* .TYPOGRAPHY_SIZE */ .y3)),
    mobileSize: prop_types__WEBPACK_IMPORTED_MODULE_5___default().oneOf(Object.values(_utils_useTypography__WEBPACK_IMPORTED_MODULE_1__/* .TYPOGRAPHY_SIZE */ .y3)),
    onClick: (prop_types__WEBPACK_IMPORTED_MODULE_5___default().func),
    tabIndex: (prop_types__WEBPACK_IMPORTED_MODULE_5___default().string),
    role: (prop_types__WEBPACK_IMPORTED_MODULE_5___default().string)
};
/* harmony default export */ __webpack_exports__["default"] = (Typography);


/***/ }),

/***/ 18422:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "tj": function() { return /* binding */ useTypography; },
/* harmony export */   "w1": function() { return /* binding */ TYPOGRAPHY_TAGS; },
/* harmony export */   "y3": function() { return /* binding */ TYPOGRAPHY_SIZE; }
/* harmony export */ });
/* harmony import */ var _swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(14924);
/* harmony import */ var _swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(26042);
/* harmony import */ var _swc_helpers_src_object_without_properties_mjs__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(99534);
/* harmony import */ var classnames__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(94184);
/* harmony import */ var classnames__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(classnames__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var react_redux__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(2664);
/* harmony import */ var redux_selectors_layout__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(19341);
/* harmony import */ var _styles_module_scss__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(34461);
/* harmony import */ var _styles_module_scss__WEBPACK_IMPORTED_MODULE_4___default = /*#__PURE__*/__webpack_require__.n(_styles_module_scss__WEBPACK_IMPORTED_MODULE_4__);







var TYPOGRAPHY_TAGS = {
    h1: "h1",
    h2: "h2",
    h3: "h3",
    h4: "h4",
    h5: "h5",
    h6: "h6",
    p: "p",
    span: "span"
};
var TYPOGRAPHY_SIZE = {
    caption12: "caption",
    paragrapgh14: "paragrapgh-s",
    paragrapgh16: "paragrapgh-m",
    headline20: "headline-xs",
    headline24: "headline-s",
    headline38: "headline-m",
    headline46: "headline-l",
    headline56: "headline-xl"
};
var useTypography = function(_param) {
    var variant = _param.variant, isBold = _param.isBold, className = _param.className, children = _param.children, size = _param.size, mobileSize = _param.mobileSize, onClick = _param.onClick, tabIndex = _param.tabIndex, role = _param.role, rest = (0,_swc_helpers_src_object_without_properties_mjs__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)(_param, [
        "variant",
        "isBold",
        "className",
        "children",
        "size",
        "mobileSize",
        "onClick",
        "tabIndex",
        "role"
    ]);
    var isDesktopResolution = (0,react_redux__WEBPACK_IMPORTED_MODULE_1__.useSelector)(redux_selectors_layout__WEBPACK_IMPORTED_MODULE_3__/* .selectIsDesktop */ .Y6);
    var Tag = TYPOGRAPHY_TAGS[variant] || variant;
    var actualSize = isDesktopResolution || !mobileSize ? size : mobileSize;
    var classes = classnames__WEBPACK_IMPORTED_MODULE_0___default()((_styles_module_scss__WEBPACK_IMPORTED_MODULE_4___default().typography), className, (_styles_module_scss__WEBPACK_IMPORTED_MODULE_4___default())[actualSize], (0,_swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z)({}, (_styles_module_scss__WEBPACK_IMPORTED_MODULE_4___default().boldText), isBold));
    return (0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z)({
        Tag: Tag,
        children: children,
        classes: classes,
        onClick: onClick,
        tabIndex: tabIndex,
        role: role
    }, rest);
};


/***/ }),

/***/ 12076:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "default": function() { return /* binding */ sections_SvgListSection; }
});

// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_spread.mjs
var _object_spread = __webpack_require__(26042);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_spread_props.mjs
var _object_spread_props = __webpack_require__(69396);
// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./node_modules/prop-types/index.js
var prop_types = __webpack_require__(45697);
var prop_types_default = /*#__PURE__*/__webpack_require__.n(prop_types);
// EXTERNAL MODULE: ./node_modules/next/dynamic.js
var dynamic = __webpack_require__(5152);
var dynamic_default = /*#__PURE__*/__webpack_require__.n(dynamic);
// EXTERNAL MODULE: ./node_modules/classnames/index.js
var classnames = __webpack_require__(94184);
var classnames_default = /*#__PURE__*/__webpack_require__.n(classnames);
// EXTERNAL MODULE: ./UI/components/SectionTitle/index.jsx
var SectionTitle = __webpack_require__(15805);
// EXTERNAL MODULE: ./utils/constants.js
var constants = __webpack_require__(96076);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./utils/helper.js
var helper = __webpack_require__(6572);
;// CONCATENATED MODULE: ./UI/sections/SvgListSection/utils/helpers.js

var getSvgSectionProps = function(data) {
    var ref = (0,helper/* getDocumentFields */.OA)(data, [
        "title",
        "description",
        "contentModules",
        "view", 
    ]), title = ref.title, description = ref.description, contentModules = ref.contentModules, view = ref.view;
    var link = contentModules.find(function(modules) {
        var ref, ref1, ref2;
        return (modules === null || modules === void 0 ? void 0 : (ref = modules.sys) === null || ref === void 0 ? void 0 : (ref1 = ref.contentType) === null || ref1 === void 0 ? void 0 : (ref2 = ref1.sys) === null || ref2 === void 0 ? void 0 : ref2.id) === "link";
    });
    var iconsGroups = contentModules.filter(function(modules) {
        var ref, ref1, ref2;
        return (modules === null || modules === void 0 ? void 0 : (ref = modules.sys) === null || ref === void 0 ? void 0 : (ref1 = ref.contentType) === null || ref1 === void 0 ? void 0 : (ref2 = ref1.sys) === null || ref2 === void 0 ? void 0 : ref2.id) !== "link";
    });
    return {
        title: title,
        description: description,
        link: link,
        view: view,
        iconsGroups: iconsGroups
    };
};

;// CONCATENATED MODULE: ./UI/sections/SvgListSection/utils/useSvgListSection.js



var useSvgListSection = function(param) {
    var section = param.section, data = param.data, handleOnCTAClick = param.handleOnCTAClick, type = param.type, withSelector = param.withSelector;
    var ref = (0,react.useMemo)(function() {
        return getSvgSectionProps(section || data);
    }, [
        section,
        data
    ]), title = ref.title, description = ref.description, link = ref.link, view = ref.view, iconsGroups = ref.iconsGroups;
    var ref1 = (0,react.useState)(null), selectedGroupIndex = ref1[0], setSelectedGroupIndex = ref1[1];
    var displayNames = (0,react.useMemo)(function() {
        return iconsGroups.map(function(group) {
            return (0,helper/* getDocumentFields */.OA)(group, [
                "title"
            ]).title;
        });
    }, [
        iconsGroups
    ]);
    (0,react.useEffect)(function() {
        if (!withSelector) {
            return;
        }
        setSelectedGroupIndex(0);
    }, [
        withSelector
    ]);
    return {
        title: title,
        description: description,
        link: link,
        view: view,
        iconsGroups: iconsGroups,
        handleOnCTAClick: handleOnCTAClick,
        type: type,
        withSelector: withSelector,
        displayNames: displayNames,
        selectedGroupIndex: selectedGroupIndex,
        handleSelectedGroupIndexChange: setSelectedGroupIndex
    };
};

// EXTERNAL MODULE: ./UI/sections/SvgListSection/styles.module.scss
var styles_module = __webpack_require__(49106);
var styles_module_default = /*#__PURE__*/__webpack_require__.n(styles_module);
;// CONCATENATED MODULE: ./UI/sections/SvgListSection/index.jsx










var Animated = dynamic_default()(function() {
    return __webpack_require__.e(/* import() */ 61971).then(__webpack_require__.bind(__webpack_require__, 61971));
}, {
    loadableGenerated: {
        webpack: function() {
            return [
                /*require.resolve*/(61971)
            ];
        }
    }
});
var CallToAction = dynamic_default()(function() {
    return Promise.all(/* import() */[__webpack_require__.e(25675), __webpack_require__.e(49617)]).then(__webpack_require__.bind(__webpack_require__, 49617));
}, {
    loadableGenerated: {
        webpack: function() {
            return [
                /*require.resolve*/(49617)
            ];
        }
    }
});
var Selector = dynamic_default()(function() {
    return Promise.all(/* import() */[__webpack_require__.e(30719), __webpack_require__.e(15282)]).then(__webpack_require__.bind(__webpack_require__, 84860));
}, {
    loadableGenerated: {
        webpack: function() {
            return [
                /*require.resolve*/(84860)
            ];
        }
    },
    ssr: false
});
var SvgGroup = dynamic_default()(function() {
    return Promise.all(/* import() */[__webpack_require__.e(30719), __webpack_require__.e(32517)]).then(__webpack_require__.bind(__webpack_require__, 32517));
}, {
    loadableGenerated: {
        webpack: function() {
            return [
                /*require.resolve*/(32517)
            ];
        }
    }
});
var SvgListSection = function(props) {
    var ref = useSvgListSection(props), title = ref.title, description = ref.description, link = ref.link, view = ref.view, iconsGroups = ref.iconsGroups, handleOnCTAClick = ref.handleOnCTAClick, type = ref.type, withSelector = ref.withSelector, handleSelectedGroupIndexChange = ref.handleSelectedGroupIndexChange, displayNames = ref.displayNames, selectedGroupIndex = ref.selectedGroupIndex;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("section", {
        className: classnames_default()((styles_module_default()).section, (styles_module_default())[type], (styles_module_default())[view]),
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(SectionTitle["default"], {
                title: title,
                description: description,
                titleStyle: (styles_module_default()).titleStyle
            }),
            withSelector && /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Selector, {
                        type: type,
                        displayNames: displayNames,
                        selectedIndex: selectedGroupIndex,
                        onSelectedIndexChange: handleSelectedGroupIndexChange
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(SvgGroup, {
                        type: type,
                        view: view,
                        data: iconsGroups[selectedGroupIndex],
                        className: (styles_module_default()).svgList,
                        isSwiperEnabled: true,
                        hideTitle: true
                    })
                ]
            }),
            !withSelector && iconsGroups.map(function(group, i) {
                return /*#__PURE__*/ (0,jsx_runtime.jsx)(SvgGroup, {
                    type: type,
                    data: group,
                    view: view,
                    className: classnames_default()((styles_module_default()).svgList, (styles_module_default())["svgList".concat(i + 1)]),
                    isSwiperEnabled: true
                }, i);
            }),
            link && /*#__PURE__*/ (0,jsx_runtime.jsx)(Animated, (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, constants/* REVEAL_ANIMATION_PROPS */.kt), {
                transitionDelay: 50,
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(CallToAction, {
                    data: link,
                    handleOnClick: handleOnCTAClick,
                    className: (styles_module_default()).callToAction
                })
            }))
        ]
    });
};
SvgListSection.defaultProps = {
    handleOnCTAClick: function() {},
    withSelector: false
};
SvgListSection.propTypes = {
    section: prop_types_default().instanceOf(Object).isRequired,
    handleOnCTAClick: (prop_types_default()).func,
    type: (prop_types_default()).string.isRequired,
    withSelector: (prop_types_default()).bool
};
/* harmony default export */ var sections_SvgListSection = (SvgListSection);


/***/ }),

/***/ 89494:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"sectionTitleContainer":"styles_sectionTitleContainer__YEeiB","title":"styles_title__m075V","subtitle":"styles_subtitle__2fL8O","description":"styles_description__WuHDh","default":"styles_default__R0jjX","side":"styles_side___qNH3"};

/***/ }),

/***/ 34461:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"boldText":"styles_boldText__iI9uz","headline-xl":"styles_headline-xl__HRBMS","headline-l":"styles_headline-l__Veh_x","headline-m":"styles_headline-m__gfh2N","headline-s":"styles_headline-s___kodX","headline-xs":"styles_headline-xs__XhN56","paragrapgh-m":"styles_paragrapgh-m__QFKni","paragrapgh-s":"styles_paragrapgh-s__4Eq1X","caption":"styles_caption__y7HHJ"};

/***/ }),

/***/ 49106:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"cardsWithFullWidthImage":"styles_cardsWithFullWidthImage__Kml_h","cards":"styles_cards__KFUWI","imageWrapper":"styles_imageWrapper__K2UHU","typeTitle":"styles_typeTitle__Wwc80","greySection":"styles_greySection__1a5nw","book-a-call":"styles_book-a-call__2MxZc","secondSectionView":"styles_secondSectionView__54u21","firstSectionView":"styles_firstSectionView__apAEN","cross-platform-development-services":"styles_cross-platform-development-services__P0RKV","machine-learning-development-services":"styles_machine-learning-development-services__aF94N","android-mobile-app-development-services":"styles_android-mobile-app-development-services__FR5lW","web-app-development-company":"styles_web-app-development-company__aSdDw","mvp-app-development-company":"styles_mvp-app-development-company__EFWVJ","mobile-app-development-company":"styles_mobile-app-development-company__w_gpP","callToAction":"styles_callToAction__yLnHH","threeColumnsCards":"styles_threeColumnsCards__tHh9O","twoColumnsCards":"styles_twoColumnsCards__0cjqH","textContent":"styles_textContent__vrFNv","section":"styles_section__H8m9I","groupTitle":"styles_groupTitle__8515K","artificial-intelligence-development-services":"styles_artificial-intelligence-development-services__FBY_B","chat-app-development-company":"styles_chat-app-development-company__jan87","svgList1":"styles_svgList1__LrP4q","svgList2":"styles_svgList2__9aVHN","svgList3":"styles_svgList3__RGmrX","enterprise-resource-planning-software-services":"styles_enterprise-resource-planning-software-services__1WEWL","description":"styles_description__8xB1t","ios-mobile-app-development-services":"styles_ios-mobile-app-development-services__pRrWM","titleStyle":"styles_titleStyle__AlY7t","svgList":"styles_svgList__YgdUF","cloud-based-app-development-services":"styles_cloud-based-app-development-services__TFPFu","data-science-development-company":"styles_data-science-development-company___eX5s","lending-software-development":"styles_lending-software-development__B_xc_","e-wallet-app-development":"styles_e-wallet-app-development__qvnLY","banking-software-development-company":"styles_banking-software-development-company___ISdT","crowdfunding-platform-development-company":"styles_crowdfunding-platform-development-company__63JZy","pwa-development-services":"styles_pwa-development-services__UNkT2","payment-gateway-development-company":"styles_payment-gateway-development-company__g4YTi","software-quality-assurance-services":"styles_software-quality-assurance-services__Z_iBs","billing-software-development-services":"styles_billing-software-development-services__zU2Z8","software-development-columbus":"styles_software-development-columbus__8mTIM","software-development-new-orleans":"styles_software-development-new-orleans__ebyBJ","software-development-tulsa":"styles_software-development-tulsa__pKgWy","software-development-minneapolis":"styles_software-development-minneapolis__5L0Ee","software-development-miami":"styles_software-development-miami__n_Luw","software-development-washington":"styles_software-development-washington__lUDs6","software-development-oklahoma":"styles_software-development-oklahoma__M_ZX8","software-development-nashville":"styles_software-development-nashville__7efFG","software-development-omaha":"styles_software-development-omaha__c2uZu","software-development-raleigh":"styles_software-development-raleigh__EVXsE","why-us":"styles_why-us__l1WCw","company":"styles_company__66f1u","logistics-software-development-services":"styles_logistics-software-development-services__YSNGn","e-commerce-development":"styles_e-commerce-development__u9h37","travel-and-hospitality-software-development":"styles_travel-and-hospitality-software-development__tytwC","educational-software-development-services":"styles_educational-software-development-services__3l8la","healthcare-software-development-services":"styles_healthcare-software-development-services__aZrlG"};

/***/ })

}]);